<script>
export default {
    name: 'countdown',

    props:
    {
        date: {
            type: String,
            coerce: str => Math.trunc(Date.parse(str) / 1000)
        },
    },

    computed: 
    {
        dateTime()
        {
            return  Math.trunc(this.$moment(this.date).format('x'))
        },

        seconds() 
        {
            return this.dateTime - this.now > 0 ? Math.trunc((this.dateTime - this.now) / 1000) % 60 : '00'
        },

        minutes() 
        {
            return this.dateTime - this.now > 0 ? Math.trunc((this.dateTime - this.now) / 1000 / 60) % 60 : '00'
        },

        hours() 
        {
            return this.dateTime - this.now > 0 ? Math.trunc((this.dateTime - this.now) / 1000 / 60 / 60) % 24 : '00'
        },

        days() 
        {
            return this.dateTime - this.now > 0 ? Math.trunc((this.dateTime - this.now) / 1000 / 60 / 60 / 24) : '00'
        },

        text()
        {
            const hours = this.twoDigits(this.hours)
            const minutes = this.twoDigits(this.minutes)
            const seconds = this.twoDigits(this.seconds)

            return this.$t('HOME.COUNTDOWN_DAY', { days: this.days }) + ' ' + hours + ':' + minutes + ':' + seconds
        },

    },

    methods:
    {
        twoDigits(value)
        {
            return value.toString().length <= 1 ? "0" + value.toString() : value.toString()
        }
    },

    data() 
    {
        return {
            now: Math.trunc(this.$moment().format('x')),
        }
    },

    created() 
    {
        window.setInterval(() => {
            this.now = Math.trunc(this.$moment().format('x'))
        }, 1000)
    },
}

</script>

<template lang="pug">
    .countdown
        .time-part.d-flex.align-items-center
            justfit-heading.m-0.font-weight-heavy(:level="3" v-if="text") {{ text }}
</template>

<style lang="scss">
    .time-element {
        padding: 12px 0;
    }
    .type {
        color: white;
        margin: 0 6px 0 0;
    }
</style>
